/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { alert_datetime } from '../models/alert_datetime';
import type { alert_id } from '../models/alert_id';
import type { AlertComment } from '../models/AlertComment';
import type { AlertCommentListResponse } from '../models/AlertCommentListResponse';
import type { AlertCommentPayload } from '../models/AlertCommentPayload';
import type { AlertCommentsReadPayload } from '../models/AlertCommentsReadPayload';
import type { AlertListResponse } from '../models/AlertListResponse';
import type { AlertMapPointsResource } from '../models/AlertMapPointsResource';
import type { AlertQualificationPayload } from '../models/AlertQualificationPayload';
import type { AlertQualificationStatus } from '../models/AlertQualificationStatus';
import type { AlertResource } from '../models/AlertResource';
import type { AlertSharePayload } from '../models/AlertSharePayload';
import type { AlertShareResource } from '../models/AlertShareResource';
import type { AlertUnreadCommentsResource } from '../models/AlertUnreadCommentsResource';
import type { cluster_alert_id } from '../models/cluster_alert_id';
import type { cluster_id } from '../models/cluster_id';
import type { contract_id } from '../models/contract_id';
import type { event_id } from '../models/event_id';
import type { limit } from '../models/limit';
import type { offset } from '../models/offset';
import type { vod_id } from '../models/vod_id';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AlertsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List alerts
     * List alerts with pagination and filters. Requires alerts.read; results are always restricted to the authenticated application's contract, including when scope.contracts.all is granted.
     * @returns AlertListResponse Alerts list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public alertControllerGetAlerts({
        alertId,
        offset,
        limit,
        vodId,
        eventId,
        carId,
        clusterId,
        contractId,
        clusterAlertId,
        minDate,
        maxDate,
        qualificationStatus,
        hasUnreadComments,
    }: {
        /**
         * Filter alerts by local alert id.
         */
        alertId?: alert_id,
        offset?: offset,
        limit?: limit,
        /**
         * Filter alerts by VOD id.
         */
        vodId?: vod_id,
        /**
         * Filter alerts by event id.
         */
        eventId?: event_id,
        /**
         * Filter alerts by the car of their VOD.
         */
        carId?: number,
        /**
         * Filter alerts by cluster id.
         */
        clusterId?: cluster_id,
        /**
         * Filter alerts by contract id.
         */
        contractId?: contract_id,
        /**
         * Filter alerts by remote cluster alert id.
         */
        clusterAlertId?: cluster_alert_id,
        /**
         * Filter alerts with date greater than or equal to this UTC datetime (inclusive).
         */
        minDate?: alert_datetime,
        /**
         * Filter alerts with date lower than or equal to this UTC datetime (inclusive).
         */
        maxDate?: alert_datetime,
        /**
         * Filter alerts by operator qualification; repeat the parameter to accept several. UNQUALIFIED returns the alerts still to be categorized.
         */
        qualificationStatus?: Array<AlertQualificationStatus>,
        /**
         * true returns only the alerts with comments the authenticated user has not read (see unread_comments).
         */
        hasUnreadComments?: boolean,
    }): CancelablePromise<AlertListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/alerts',
            query: {
                'alert_id': alertId,
                'offset': offset,
                'limit': limit,
                'vod_id': vodId,
                'event_id': eventId,
                'car_id': carId,
                'cluster_id': clusterId,
                'contract_id': contractId,
                'cluster_alert_id': clusterAlertId,
                'min_date': minDate,
                'max_date': maxDate,
                'qualification_status': qualificationStatus,
                'has_unread_comments': hasUnreadComments,
            },
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * List alert map points
     * Every located alert matching the same filters as GET /alerts, newest first, with only what a map needs (no thumbnail), so it can show them all before the list pages are loaded. Capped at 5000 points; truncated is then true. Requires alerts.read; results are always restricted to the authenticated application's contract.
     * @returns AlertMapPointsResource Alert map points
     * @returns any Unexpected error
     * @throws ApiError
     */
    public alertControllerGetAlertMapPoints({
        alertId,
        vodId,
        eventId,
        carId,
        clusterId,
        contractId,
        clusterAlertId,
        minDate,
        maxDate,
        qualificationStatus,
        hasUnreadComments,
    }: {
        /**
         * Filter alerts by local alert id.
         */
        alertId?: alert_id,
        /**
         * Filter alerts by VOD id.
         */
        vodId?: vod_id,
        /**
         * Filter alerts by event id.
         */
        eventId?: event_id,
        /**
         * Filter alerts by the car of their VOD.
         */
        carId?: number,
        /**
         * Filter alerts by cluster id.
         */
        clusterId?: cluster_id,
        /**
         * Filter alerts by contract id.
         */
        contractId?: contract_id,
        /**
         * Filter alerts by remote cluster alert id.
         */
        clusterAlertId?: cluster_alert_id,
        /**
         * Filter alerts with date greater than or equal to this UTC datetime (inclusive).
         */
        minDate?: alert_datetime,
        /**
         * Filter alerts with date lower than or equal to this UTC datetime (inclusive).
         */
        maxDate?: alert_datetime,
        /**
         * Filter alerts by operator qualification; repeat the parameter to accept several. UNQUALIFIED returns the alerts still to be categorized.
         */
        qualificationStatus?: Array<AlertQualificationStatus>,
        /**
         * true returns only the alerts with comments the authenticated user has not read (see unread_comments).
         */
        hasUnreadComments?: boolean,
    }): CancelablePromise<AlertMapPointsResource | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/alerts/map-points',
            query: {
                'alert_id': alertId,
                'vod_id': vodId,
                'event_id': eventId,
                'car_id': carId,
                'cluster_id': clusterId,
                'contract_id': contractId,
                'cluster_alert_id': clusterAlertId,
                'min_date': minDate,
                'max_date': maxDate,
                'qualification_status': qualificationStatus,
                'has_unread_comments': hasUnreadComments,
            },
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Count unread alert comments
     * Counts the comments the authenticated user has not read on the alerts of the authenticated application's contract (see unread_comments). Requires alerts.read.
     * @returns AlertUnreadCommentsResource Unread comments
     * @returns any Unexpected error
     * @throws ApiError
     */
    public alertControllerGetUnreadComments(): CancelablePromise<AlertUnreadCommentsResource | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/alerts/unread-comments',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Qualify an alert
     * Sets the operator qualification of an alert of the authenticated application's contract. Requires alerts.qualify. UNQUALIFIED puts the alert back to be categorized.
     * @returns AlertResource Qualified alert
     * @returns any Unexpected error
     * @throws ApiError
     */
    public alertControllerPutQualification({
        alertId,
        requestBody,
    }: {
        alertId: alert_id,
        requestBody: AlertQualificationPayload,
    }): CancelablePromise<AlertResource | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/alerts/{alert_id}/qualification',
            path: {
                'alert_id': alertId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * List alert comments
     * Comments and qualification changes of an alert, oldest first, including those posted from its share links. Requires alerts.read; only alerts of the authenticated application's contract.
     * @returns AlertCommentListResponse Alert comments
     * @returns any Unexpected error
     * @throws ApiError
     */
    public alertControllerGetComments({
        alertId,
    }: {
        alertId: alert_id,
    }): CancelablePromise<AlertCommentListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/alerts/{alert_id}/comments',
            path: {
                'alert_id': alertId,
            },
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Comment an alert
     * Adds a comment to an alert, also shown on its share links. Requires alerts.read; only alerts of the authenticated application's contract.
     * @returns any Unexpected error
     * @returns AlertComment Created comment
     * @throws ApiError
     */
    public alertControllerPostComment({
        alertId,
        requestBody,
    }: {
        alertId: alert_id,
        requestBody: AlertCommentPayload,
    }): CancelablePromise<{
        code: number;
        message: string;
    } | AlertComment> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/alerts/{alert_id}/comments',
            path: {
                'alert_id': alertId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Mark alert comments as read
     * Marks the comments of an alert as read by the authenticated user, up to last_comment_id or up to the latest one. The marker never moves back. Requires alerts.read; only alerts of the authenticated application's contract.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public alertControllerPutCommentsRead({
        alertId,
        requestBody,
    }: {
        alertId: alert_id,
        requestBody: AlertCommentsReadPayload,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/alerts/{alert_id}/comments/read',
            path: {
                'alert_id': alertId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Create an alert share link
     * Creates a public link to a page showing the alert image, date and position, for recipients without an account. Messaging apps display the image as the link preview. Whoever holds the link can comment the alert and set it to INVESTIGATING, FALSE_ALARM or SECURED from that page. The link expires after 7 days. Requires alerts.read; only alerts of the authenticated application's contract can be shared.
     * @returns any Unexpected error
     * @returns AlertShareResource Created share link
     * @throws ApiError
     */
    public alertControllerPostShare({
        alertId,
        requestBody,
    }: {
        alertId: alert_id,
        requestBody: AlertSharePayload,
    }): CancelablePromise<{
        code: number;
        message: string;
    } | AlertShareResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/alerts/{alert_id}/shares',
            path: {
                'alert_id': alertId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
